module.exports = __webpack_public_path__ + "static/insert_legend_3-537dd0c5acbfed0d3cfeeb151cb52066.png";